import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import Implementations from "../../../../../components/connectorConfiguration/implementations";
import Configure from "../../../../../components/connectorConfiguration/configure";
export const getConnectorConfigurationBasePath = () => `${getAdminBasePath()}/connectorConfiguration`;
export const getConnectorConfigurationIndexPath = () => `${getAdminBasePath()}/index`;
export const getConnectorConfigurationConfigureStreamPath = (streamName, selectedImplementation) => `${getAdminBasePath()}/${streamName}/${selectedImplementation}`;
export const getConnectorConfigurationBaseRoute = () => `${getAdminBaseRoute()}/connectorConfiguration`;
export const getConnectorConfigurationIndexRoute = () => `${getAdminBaseRoute()}/index`;
export const getConnectorConfigurationConfigureStreamRoute = () => `${getAdminBaseRoute()}/:streamName/:selectedImplementation`;
const AdminConnectorConfigurationRoutes = () => {
    return (_jsxs(Switch, { children: [_jsx(Route, { component: Implementations, path: getConnectorConfigurationIndexRoute() }), _jsx(Route, { component: Configure, path: getConnectorConfigurationConfigureStreamRoute() })] }));
};
export default AdminConnectorConfigurationRoutes;
